import React from 'react';
import { Input } from 'reactstrap';

class CustomInput extends Input {
  constructor(props) {
    super(props);
  }
}

export default CustomInput;

const ReduxInput = ({
  input,
  type,
  name,
  id,
  value,
  onChange,
  onBlur,
  placeholder,
  defaultValue,
  meta,
  className,
  disabled,
  maxLength,
  mobileFormat,
  tabIndex,
  style,
  fieldName,
  min,
  max,
  controlledMaxAge,
  negativeNumberBlocked,
  showPlaceHolder,
  disableOnPaste,
}) => {
  var { touched, error, warning, active } = meta || {};
  if (input) {
    defaultValue = input.defaultValue;
    value = input.value && input.value.toString();
    //above line is not accepting "0" as value because of && condition and field label is overlpapping because of that
    // value = input.value.toString();
    // need to check causing issues in fieldArray form.
    // if (input.value || input.value === 0) {
    //   value = input.value.toString();
    // }
    onChange = input.onChange;
    onBlur = input.onBlur;
    name = input.name;
  }

  /*if(mobileFormat){
        value = Util.formatPhoneNumber(value);
    }*/

  return (
    <>
      {!controlledMaxAge ? (
        !negativeNumberBlocked ? (
          <CustomInput
            {...input}
            style={style}
            tabIndex={tabIndex}
            type={type}
            name={name}
            id={id}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            // placeholder={active && placeholder}
            placeholder={showPlaceHolder ? placeholder : active && placeholder}
            className={`${className} ${type == 'number' && 'numeric-only-field'} ${value !==
              undefined &&
              value !== null &&
              value.toString() &&
              'not-empty'} ${type == 'textarea' && 'textarea-height'}`}
            disabled={!!disabled}
            maxLength={maxLength}
            autocomplete="off"
            min={min}
            max={max}
            onKeyDown={
              type == 'number'
                ? evt => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()
                : null
            }
            onPaste={e => {
              if (disableOnPaste) {
                e.preventDefault();
              }
            }}
            onWheel={event => {
              window.document.activeElement.blur();
            }}
          />
        ) : (
          <CustomInput
            {...input}
            style={style}
            tabIndex={tabIndex}
            type={type}
            name={name}
            id={id}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={active && placeholder}
            className={`${className} ${value !== undefined &&
              value !== null &&
              value.toString() &&
              'not-empty'}`}
            disabled={!!disabled}
            maxLength={maxLength}
            autocomplete="off"
            min={min}
            // max={max}
            onKeyDown={
              type == 'number'
                ? evt => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()
                : null
            }
            onPaste={e => {
              if (disableOnPaste) {
                e.preventDefault();
              }
            }}
            onWheel={event => {
              window.document.activeElement.blur();
            }}
          />
        )
      ) : (
        <CustomInput
          {...input}
          style={style}
          tabIndex={tabIndex}
          type={type}
          name={name}
          id={id}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={active && placeholder}
          className={`${className} ${value !== undefined &&
            value !== null &&
            value.toString() &&
            'not-empty'}`}
          disabled={!!disabled}
          maxLength={maxLength}
          autocomplete="off"
          min={min}
          max={max}
          onKeyDown={
            type == 'number'
              ? evt => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()
              : null
          }
          onPaste={e => {
            if (disableOnPaste) {
              e.preventDefault();
            }
          }}
          onWheel={event => {
            window.document.activeElement.blur();
          }}
          //   onKeyPress={function(evt) {
          //     evt.preventDefault();
          //   }
          // }
        />
      )}

      {touched &&
        ((error && fieldName && (
          <span className="error-text">
            {fieldName} {error}
          </span>
        )) ||
          (warning && <span className="warning-color">{warning}</span>))}
    </>
  );
};

export { ReduxInput };
